import React from 'react';
import moment from 'moment';
import 'moment/locale/pt-br';
import { MdPayment } from 'react-icons/md';
import { HiOutlineArrowNarrowRight } from 'react-icons/hi';
import { Container, Div, Title, Subtitle, Icon, IconMobile } from './styles';
import { useHistory } from 'react-router-dom';
import { formatPlate } from 'react-data-formatter';

function InstallmentItem({ installment, commercial }) {
  const history = useHistory();

  const navigate = (e) => {
    e.preventDefault();
    if (commercial) {
      history.push(`/comercial/detalhes-da-apolice/${installment?.apolice_id}`);
      return;
    }
    history.push(`/backoffice/detalhes-da-apolice/${installment?.apolice_id}`);
  };

  return (
    <Container onClick={navigate}>
      <div className="description">
        <div className="iconInstallment">
          <MdPayment size={23} color={installment?.data_da_baixa ? '#4CAF50' : '#FF9800'} />
        </div>

        <Div>
          <Title>Parcela {installment?.numero_da_parcela}</Title>
          <Subtitle>Apólice: {installment?.policy_number}</Subtitle>
        </Div>

        <Div>
          <Title>{installment?.vehicle?.model || 'Modelo não informado'}</Title>
          <Subtitle>
            Placa: {installment?.vehicle?.plate ? formatPlate(installment?.vehicle?.plate) : 'Sem placa'}
          </Subtitle>
        </Div>

        <Div>
          <Title color={installment?.data_da_baixa ? '#4CAF50' : '#FF9800'}>
            {installment?.data_da_baixa ? 'Baixada' : 'Não baixada'}
          </Title>
          <Subtitle>Vencimento: {moment(installment?.data_vencimento_parcela).format('DD/MM/YYYY')}</Subtitle>
        </Div>

        <Icon>
          <HiOutlineArrowNarrowRight color="#C4C4C4" size={25} className="iconArrow" />
        </Icon>

        <IconMobile>
          <MdPayment size={40} color={installment?.data_da_baixa ? '#4CAF50' : '#FF9800'} />
        </IconMobile>
      </div>
    </Container>
  );
}

export default InstallmentItem;
